<template>
  <div class="eyedrops">
    <div class="section-image">
      <b-container>
        <b-row>
          <b-col>
            <h1 class="text-center section-name">Ögondroppar inneliggande patient</h1>
          </b-col>
        </b-row>
      </b-container>
      <b-container>
        <b-row>
          <b-col>
            <b-form-input v-model="search"
              type="text"
              autocapitalize="off"
              autocorrect="off"
              spellcheck="false"
              placeholder="Sök i dokumenttext" class="drug-search" @keydown.enter.exact="$refs.pdfComp.gotoMatch(1)" @keydown.shift.enter="$refs.pdfComp.gotoMatch(-1)" @keydown.esc="search = ''" />
            </b-col>
        </b-row>
      </b-container>
    </div>
    <b-container fluid>
      <b-row>
        <b-col>
          <!-- <pdf-viewer ref="pdfComp" src="/ogondroppar-till-inneliggande-patienter-som-inte-har-med-sig-egna.pdf" :scale="1.3" :searchString="this.search" /> -->
          <pdf-viewer ref="pdfComp" pdfDbEntryKey="eyedropsPdf" :scale="0.74" :searchString="this.search" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { sortBy, toLower, includes, cloneDeep } from 'lodash'
import { computed, onMounted, reactive, toRefs } from '@vue/composition-api'
import { getEyedropCommonRecommendation } from '../store/actions'
import { clickTracker } from '@/services/helpers'
import axios from 'axios'
import PdfViewer from '../components/PdfViewer'

const newEyedrop = {
  eyedropsRecordId: -1,
  fromEyedrops: '',
  toEyedropsA: '',
  normalDoseIdA: 0,
  normalDoseTextA: '', // required, but ignored in BE
  toEyedropsB: '',
  normalDoseIdB: 0,
  normalDoseTextB: '', // required, but ignored in BE
  isPublished: false,
  changeDate: 'ignoreme' // required, but ignored in BE
}

export default {
  name: 'EyeDrops',
  components: {
    'pdf-viewer': PdfViewer
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    generalInstructions () {
      return this.$store.getters.eyedropGeneralRecommendation
    }
  },
  mounted () {
    if (this.generalInstructions.text.length === 0) {
      getEyedropCommonRecommendation(this.$store)
    }
    clickTracker('keyEyedropList')
  },
  setup () {
    const state = reactive({
      search: '',
      eyedropsList: [],
      showDialog: false,
      selectedEyedrop: cloneDeep(newEyedrop)
    })

    onMounted(() => {
      getEyedropsList()
    })

    function getEyedropsList () {
      axios.get('eyedrops/getEyeDropsRecordListForDisplay')
        .then((result) => {
          state.eyedropsList = result.data
        })
        .catch((error) => {
          console.log(error)
        })
    }

    function toggleDialog (drop) {
      state.showDialog = !state.showDialog
      if (state.showDialog) {
        state.selectedEyedrop = cloneDeep(drop || newEyedrop)
      }
    }

    const filteredList = computed(() => {
      if (!state.search) {
        return state.eyedropsList
      } else {
        const filterString = toLower(state.search)
        return state.eyedropsList.filter(drop =>
          includes(toLower(drop.fromEyedrops), filterString) ||
          includes(toLower(drop.toEyedropsA), filterString) ||
          includes(toLower(drop.toEyedropsB), filterString)
        )
      }
    })
    const sortedList = computed(() => sortBy(filteredList.value, item => toLower(item.fromEyedrops)))

    return {
      ...toRefs(state),
      toggleDialog,
      getEyedropsList,
      sortedList
    }
  }
}
</script>
<style scoped lang="scss">
h1, h2 {
  font-weight: normal;
}

h4 {
  margin-bottom: 0;
}

ul {
  padding-left: 10px;
  @media (min-width: 768px) {
    padding-left:15px;
  }
}

ul li {
  list-style: none;
}

  i.fa {
    color: $orange;
    margin-top: 8px;
  }

.substitute-container {
  padding: 10px;
  margin-right: 0px;

  h4 {
    color: $grafit;
  }
}

.substitute-subrow {
  // padding: 10px;
  margin-right: 0px;
  display: flex;
  h5 {
    color: $grafit;
  }
}

.row-footer {
  padding: 0px 15px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.substitute-container-1 {
  background: $grå8;
}

.drug-search {
  margin: 20px 0;
  padding: 10px;
}

.section-name {
  color: white;
  margin: 0;
  font-weight: bold;
  font-size: 25pt;
  text-shadow: 0 0 10px #888
}

.section-image {
  padding-top: 25px;
  top: 70px;
  z-index: -1;
  height: 170px;
  width: 100%;
  background-image: url('../assets/eyedrop-background.jpg');
  background-position-y: bottom;
  background-size: cover;
}

.no-sub-category {
  margin-top: 10px;
}

li.nav-item {
  width: 50%;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  max-width: 400px;
}

.general-info {
  padding: 10px 0;
}

.drug-from {
  padding-bottom: 1rem;
  > h4 {
    margin-bottom: 0;
    overflow-wrap: break-word;
  }
}

.drug-to {
  > h5 {
    color: $grafit;
    overflow-wrap: break-word;
  }
}

.publish-indicator {
  padding-right: 1rem;
}
</style>



